import React from "react";
//#region types
import { GraphConstants, IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { ArticleChartProps, ArticlesWidgetAPIProps } from "models/propTypes/articlePropTypes";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
//#endregion
//#region components
import { ChartContainer } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const ArticleStatisticsSummeryNumberChart: React.FC<ArticleChartProps> = (props) => {
  const filter: Omit<ArticlesWidgetAPIProps, keyof WintUtilsWebApi.Filter> = {
    articleId: props.articleId,
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Number}
      chartAPIKey={GraphConstants.ChartKeys.ArticleStatisticSummary}
      filter={filter}
      numberChartIcon={IconDefinitionConstants.WMoney}
      chartTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.InvoicedAmount)}
    />
  );
};

export default ArticleStatisticsSummeryNumberChart;
